import Api from "services/Api";
import _ from 'lodash';
import {chartDataSets, chartTicks, confidenceChartDataSets} from 'store/modules/shared/chartDataSets';
import {tableData} from 'store/modules/shared/tableData';
import dayOneFatal from './dayOneFatal';
import dayOneLost from './dayOneLost';
import compare from './compare';

/**
 * Mutation Types
 *
 * @type {Object}
 */
const mutationTypes = {
    RESET: 'RESET',
    UPDATE_FILTER: 'UPDATE_FILTER',
    UPDATE_RESULTS: 'UPDATE_RESULTS'
};

/**
 * Template for summary period
 */
function summaryPeriodTemplate()  {
    return {
        average_initial_reserve: [],
        reserve_range: [],
        new_claims: [],
    }
}

/**
 * Template for a graph
 */
function graphTemplate()  {
    return {
        data: {
            fatal: [],
            lost: [],
        },
    }
}

/**
 * State.
 *
 * @type {Object}
 */
const state = {
    dayOneAssessmentFilter: {
        claimStatus: null,
        claimType: null,
        discountRate: null,
        diseaseType: null,
        onsetOfSymptoms: [null, null],
        gender: null,
        proceduralStatus: null,
        employedAtDeath: null,
        disabled: null,
        active: null,
        ageAtOnset: [null, null],
        ageAtDeath: [null, null],
        ageOfClaimant: [null, null],
        levelOfEducation: null,
        disabledAtAccident: null,
        serviceOfProceedings: [null, null],
    },
    dayOneAssessmentResults: {
        confidence: {
            percentage: 0
        },
        scatter: {
            labels: {
                type: ''
            },
            data: {}
        }
    },
};

/**
 * Getters.
 *
 * @type {Object}
 */
const getters = {
    getTableData: state => tableData(state),
    getAxes: state => key => state.dayOneAssessmentResults.scatter.labels[key],
    getFilter: state => key => state.dayOneAssessmentFilter[key],
    getFilters: state => state.dayOneAssessmentFilter,
    getReserveData: state => key => state.dayOneAssessmentResults[key],
    getChartTicks: state => chartTicks(state),
    getChartDataSets: state => chartDataSets(state),
    getConfidenceChartDataSet: state => confidenceChartDataSets(state),
};

/**
 * Actions.
 *
 * @type {Object}
 */
const actions = {
    /**
     * analyse the data.
     *
     * @param {dispatch}
     * @param {state}
     */
    analyse: _.debounce(({dispatch, state}) => {
        return Api.dashboards.reserving.dayOneAssessment(state.dayOneAssessmentFilter)
            .then((data) => dispatch('updateResults', {data, index: 'dayOneAssessmentResults'}));
    }, 500),

    /**
     * update search filters
     *
     * @param {commit}
     * @param key
     * @param value
     */
    updateFilters({commit}, {key, value}) {
        commit(mutationTypes.UPDATE_FILTER, {key, value});
    },

    /**
     * update results
     *
     * @param {commit}
     * @param data
     * @param index
     */
    updateResults({commit}, {data, index}) {
        commit(mutationTypes.UPDATE_RESULTS, {data, index});
    },

    /**
     * reset the state
     *
     * @param {commit}
     */
    resetFilters({commit}) {
        commit(mutationTypes.RESET);
    }
};

/**
 * Mutations
 *
 * @type {Object}
 */
const mutations = {
    /**
     * Update search filters in the state.
     */
    [mutationTypes.UPDATE_FILTER](state, {key, value}) {
        state.dayOneAssessmentFilter[key] = value;
    },

    /**
     * Update results in the state.
     */
    [mutationTypes.UPDATE_RESULTS](state, {data, index}) {
        state[index] = data;
    },

    /**
     * Reset the state.
     */    
    [mutationTypes.RESET](state) {
        state.dayOneAssessmentFilter.claimType = null;
        state.dayOneAssessmentFilter.discountRate = null;
        state.dayOneAssessmentFilter.diseaseType = null;
        state.dayOneAssessmentFilter.onsetOfSymptoms = [null, null];
        state.dayOneAssessmentFilter.gender = null;
        state.dayOneAssessmentFilter.proceduralStatus = null;
        state.dayOneAssessmentFilter.employedAtDeath = null;
        state.dayOneAssessmentFilter.disabled = null;
        state.dayOneAssessmentFilter.active = null;
        state.dayOneAssessmentFilter.ageAtOnset = [null, null];
        state.dayOneAssessmentFilter.ageAtDeath = [null, null];
        state.dayOneAssessmentFilter.ageOfClaimant = [null, null];
        state.dayOneAssessmentFilter.levelOfEducation = null;
        state.dayOneAssessmentFilter.disabledAtAccident = null;
        state.dayOneAssessmentFilter.serviceOfProceedings = [null, null];

        state.dayOneAssessmentResults = {
            confidence: {
                percentage: 0
            },
            scatter: {
                labels: {
                    type: '',
                },
                data: {}
            }
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        dayOneFatal,
        dayOneLost,
        compare
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/reserves/index.js